module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tweet"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.status.profile_image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-txt"
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.status.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/" + (_vm.status.screen_name))
    }
  }, [_c('span', [_vm._v("@" + _vm._s(_vm.status.screen_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "display-text"
  }, [(_vm.status.reply_name) ? _c('p', {
    staticClass: "reply-text"
  }, [_vm._v("Replying to\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/" + (_vm.status.reply_name))
    }
  }, [_c('span', {
    staticClass: "reply-name",
    domProps: {
      "textContent": _vm._s(("@" + (_vm.status.reply_name)))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.status.displayText))])]), _vm._v(" "), (_vm.status.media) ? [_c('div', {
    staticClass: "media-container"
  }, _vm._l((_vm.status.media), function(img, i) {
    return _c('img', {
      key: i,
      staticClass: "media-image",
      attrs: {
        "src": img.media_url
      }
    })
  }))] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f3af709","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tweet.vue
// module id = 26
// module chunks = 0